'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Locale = require('./Locale');

var _Locale2 = _interopRequireDefault(_Locale);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _Locale2["default"];
module.exports = exports['default'];